import { ShortCode } from '@highereducation/wordpress';
import { BrandCard } from '@highereducation/hen-ui';

type BrandCardShortcodeProps = {
  'logo-src': string;
  'logo-alt': string;
  title: string;
  children: React.ReactNode;
  tags?: string;
  'site-url'?: string;
  'read-more-url'?: string;
};

export const BrandCardShortcode: ShortCode<BrandCardShortcodeProps> = {
  component: ({
    'logo-src': logoSrc,
    'logo-alt': logoAlt,
    title,
    children,
    tags,
    'site-url': siteUrl,
    'read-more-url': readMoreUrl,
  }) => {
    const tagsArray = tags ? tags.split(',').map((tag) => tag.trim()) : [];
    return (
      <BrandCard
        logoSrc={logoSrc}
        logoAlt={logoAlt}
        title={title}
        tags={tagsArray}
        siteUrl={siteUrl}
        readMoreUrl={readMoreUrl}
      >
        {children}
      </BrandCard>
    );
  },
};
